var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeedRectangleIcon = function SvgFeedRectangleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 2a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4zm1 16.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m-1.744-7.593a.75.75 0 0 1 .837-.651 8.826 8.826 0 0 1 7.651 7.651.75.75 0 0 1-1.488.186 7.325 7.325 0 0 0-6.349-6.349.75.75 0 0 1-.651-.837M6 5.25a.75.75 0 0 0 0 1.5c6.213 0 11.25 5.037 11.25 11.25a.75.75 0 0 0 1.5 0c0-7.042-5.708-12.75-12.75-12.75",
    clipRule: "evenodd"
  })));
};
export default SvgFeedRectangleIcon;